import type { ProductDetailPageFragmentFragment as ProductDetailPageFragment } from "@commerce-frontend/types";
import { useTranslations } from "next-intl";

type Props = {
	product: ProductDetailPageFragment;
	selectedVariant: ProductDetailPageFragment["variants"][number] | undefined;
};

export const QuantityLabels = ({ product, selectedVariant }: Props) => {
	const t = useTranslations("ProductBuySection");
	const { min, stepSize, max, hasMax } =
		selectedVariant?.orderConfiguration ?? product.primaryVariant?.orderConfiguration ?? {};
	const hasIncrement = !!stepSize && stepSize > 1;
	// if there's no selectedVariant we don't apply the stock rules and we always show the labels
	const availableQuantity = selectedVariant?.availabilityQuantity ?? Number.POSITIVE_INFINITY;
	const inStock = (quantity?: number) => quantity === undefined || availableQuantity >= quantity;

	const quantityLabels = [
		{
			key: "increment-quantity",
			show: hasIncrement && inStock(stepSize),
			value: stepSize,
		},
		{
			key: "minimum-quantity",
			show: !hasIncrement && !!min && min > 1 && inStock(min),
			value: min,
		},
		{
			key: "maximum-quantity",
			// Because "max" has a fallback number value if it's empty, we need the hasMax flag to check if we should show the label
			show: !!max && hasMax,
			value: max,
		},
	];

	return quantityLabels
		.filter(({ show }) => show)
		.map(({ key, value }) => (
			<div key={`quantity-label-${key}`} className="text-sm">
				{t.rich(key, {
					bold: (chunks) => <span className="font-bold">{chunks}</span>,
					quantity: value,
				})}
			</div>
		));
};
